<template>
      <input
        :value="value"
        v-on="$listeners"
      />
</template>
<script>
    export default {
        props: {
            value: {
                type: String,
                default: ''
            }
        }
    };
</script>